import styles from '@/components/book/KnowellName.module.css';

interface KnowellNameProps {
  /** `name`: the word. `mark`: the letter k, the compact glyph for small keys and tools. */
  variant?: 'name' | 'mark';
  className?: string;
}

/**
 * The agent's name, `knowell`, in the surrounding type and colour. The mark
 * is silent, so the control around it carries the words in its label; it
 * draws its letter as generated content, so copied text never picks up a
 * stray `k`.
 */
export function KnowellName({ variant = 'name', className }: KnowellNameProps) {
  if (variant === 'mark') return <span className={[styles.mark, className].filter(Boolean).join(' ')} aria-hidden="true" />;
  return <span className={[styles.name, className].filter(Boolean).join(' ')}>knowell</span>;
}
